<template>
  <GridTable :columns="tableColumns" :rows="todos" mode="ag-grid">
    <template #row="{row}">
      <GridTableCell class="grid items-center content-center" no-tooltip>
        <div class="text-body-4 text-ellipsis">{{ row.title }}</div>
        <Grid
          v-if="row.entity && $route.name === 'dashboard'"
          gaf="column"
          justify-content="start"
          gap="var(--r-space-xs)"
          class="entity"
        >
          <span class="text-caption-3">{{ capitalize(row.entity.type) }}:</span>
          <router-link class="text-caption-3 text-link-blue" :to="`/${row.entity.type}s/${row.entity.id}/notes-tasks`">
            {{ capitalize(row.entity.name) }}
          </router-link>
        </Grid>
      </GridTableCell>

      <GridTableCell>
        <template v-if="filter === 'Open'">
          {{ row.owners.length ? row.owners.map(o => o.name).join(', ') : 'N/A' }}
        </template>

        <template v-else>
          {{ row.completed_by.name }}
        </template>
      </GridTableCell>

      <GridTableCell :class="`text-${tableColumns[2].align}`">
        <template v-if="filter === 'Open'">
          {{ formatDateForLocale(row.deadline) || 'N/A' }}
        </template>

        <template v-else>
          {{ formatDateForLocale(row.completed_at) }}
        </template>
      </GridTableCell>

      <GridTableCell>
        {{ row.priority ? capitalize(row.priority.name) : 'N/A' }}
      </GridTableCell>

      <GridTableCell class="grid justify-center" no-tooltip>
        <Grid gaf="column" gap="var(--r-space-xs)">
          <RBtn type="tertiary" size="small" @click="$emit('done-changed', row)">
            {{ filter === 'Open' ? 'Complete' : 'Open' }}
          </RBtn>
          <DotsIcon :popup-items="popupItems" @popup-item="$emit($event.name, row)" />
        </Grid>
      </GridTableCell>
    </template>
  </GridTable>
</template>

<script>
// Components
import GridTable from '@/reusable/grid-table/GridTable'
import GridTableCell from '@/reusable/grid-table/GridTableCell'
import DotsIcon from '@/ui/icons/DotsIcon'

export default {
  components: {
    GridTable,
    GridTableCell,
    DotsIcon
  },

  props: {
    todos: Array,
    filter: String
  },

  computed: {
    tableColumns() {
      const task = { label: 'Task', width: '2fr' }
      const actions = { label: 'Actions', align: 'center', width: '1fr' }
      const priority = { label: 'Priority', width: '60px' }

      if (this.filter === 'Open')
        return [
          task,
          { label: 'Assigned to', width: '1fr' },
          { label: 'Deadline', align: 'center', width: '1fr' },
          priority,
          actions
        ]

      return [
        task,
        { label: 'Completed by', width: '1fr' },
        { label: 'Completed on', align: 'center', width: '1fr' },
        priority,
        actions
      ]
    },

    popupItems() {
      return [
        { name: 'edit', label: 'Edit' },
        { name: 'delete', label: 'Delete', textColorClass: 'text-danger-1' }
      ]
    }
  }
}
</script>
